import { render, staticRenderFns } from "./ActualizaEstatus.vue?vue&type=template&id=f7a239b0"
import script from "./ActualizaEstatus.vue?vue&type=script&lang=js"
export * from "./ActualizaEstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports